import {environment} from "../environments/environment";

export class GlobalConstant {
    public static app_name = "RMN Events";
    public static aes_seceret = "yKRHgHsvZ4fwblHqcL1WNDuNJ3JLFLVg";
    public static aes_iv = "yKRHgHsvZ4fwblHq";

    public static resourseURL = environment.RESOURCE_URL;
    // public static appURL = environment.APP_URL;

    // event management tabs
    public static timezone = [
        {
            "name": "Hawaii–Aleutian Standard Time (HST) UTC − 10",
            "value": "US/Hawaii",
            "short_name": "HST",
            "long_name": "Hawaii Standard Time"
        },
        {
            "name": "Alaska Standard Time (AKST) UTC − 9",
            "value": "US/Alaska",
            "short_name": "AKST",
            "long_name": "Alaska Time"
        },
        {
            "name": "Pacific Standard Time (PST) UTC − 8",
            "value": "US/Pacific",
            "short_name": "PST",
            "long_name": "Pacific Time"
        },
        {
            "name": "Mountain Standard Time (MST) UTC − 7",
            "value": "US/Mountain",
            "short_name": "MST",
            "long_name": "Mountain Time"
        },
        {
            "name": "Central Standard Time (CST) UTC − 6",
            "value": "US/Central",
            "short_name": "CST",
            "long_name": "Central Time"
        },
        {
            "name": "Eastern Standard Time (EST) UTC − 5",
            "value": "US/Eastern",
            "short_name": "EST",
            "long_name": "Eastern Time"
        }
    ];

    public static readonly  event_division_type = [
        {
            "value":'boys',
            "name":"Boys"
        },{
            "value":'girls',
            "name":"Girls"
        },{
            "value":'rookie',
            "name":"Rookie"
        },{
            "value":'open',
            "name":"Open"
        }
    ];

    public static readonly divisionStyles = [
        {
            "value":'freestyle',
            "name":"Freestyle"
        },{
            "value":'folkstyle',
            "name":"Folkstyle"
        },{
            "value":'greco',
            "name":"Greco"
        },{
            "value":'duals',
            "name":"Duals"
        }
    ];

    public static readonly grades = [
        {
            "value": "1st",
            "name":"1st Grade"
        },{
            "value": "2nd",
            "name":"2nd Grade"
        },{
            "value": "3rd",
            "name":"3rd Grade"
        },{
            "value": "4th",
            "name":"4th Grade"
        },{
            "value": "5th",
            "name":"5th Grade"
        }
    ];

    public static event_wrestling_type = [
        {
            "value":1,
            "name":"Free style"
        },{
            "value":2,
            "name":"Folk style"
        }
    ];

    public static readonly popupTypes = [{
        value: "general",
        name: "General"
    },{
        value: "event-specific",
        name: "Event Specific"
    }]

    public static athleteMinimumAge = 4;

    public static notificationSound = "./assets/sounds/notification-drop.wav";

    public static noTeam = "No Team";

    public static roles = [{
        key: 'owner',
        name: "Owner"
    },{
        key: "admin",
        name: "Admin"
    },{
        key: 'employee',
        name: "Employee"
    },{
        key: "user",
        name: "User"
    }];

    public static productCategories = [{
        key: "floor-passes",
        name: "Floor Passes"
    },{
        key: "general-admission",
        name: "General Admission",
    },{
        key: "event-merchandise",
        name: "Event Merchandise"
    }];

    public static readonly maxProfileImageSize = 1048576 * 5;

    public static selectOption = [
      { label: 'Monthly', value: 'monthly' },
      { label: 'Yearly', value: 'yearly' }
    ];

    public static month = [
      { label: 'April', value: 4 },
      { label: 'May', value: 5 },
      { label: 'June', value: 6},
      { label: 'July', value: 7 },
      { label: 'August', value: 8 },
      { label: 'September', value: 9 },
      { label: 'October', value: 10 },
      { label: 'November', value: 11 },
      { label: 'December', value: 12 },
      { label: 'January', value: 1 },
      { label: 'February', value: 2 },
      { label: 'March', value: 3 }
    ];

    public static financialYears = [
      '2024-2025','2023-2024', '2022-2023', '2021-2022', '2020-2021'
    ];
    public static statusOptions = [
      { label: 'Pending', value: '0' },
      { label: 'Filed', value: '1' },
      { label: 'NA', value: '2' },
      { label: 'Tax', value: '3' }
    ];
    public static returnStatus = [
      { label: 'Q', value: '0' },
      { label: 'M', value: '1' },
      { label: 'CMP', value: '2' },
      { label: 'Cancelled', value: '3' },
      { label: 'QUTR', value: '4' }
    ];
}
